<script lang="ts">
  /**
   * ClubTeaserCard — the STATIC "what a shared set looks like" example on the
   * no-club front door (spec 2026-09-01 §2, mockup j1-no-club). Hardcoded
   * numbers from the real May 27 Killer BS set (Scott vs Ryan): it exists so
   * someone who has never seen a shared morning knows what "Start a club" buys
   * them. No data flows through it; the live card is SetCompareCard.
   */
  import { strokeColor, contrastTextOn } from "../lib/designTokens";

  const chips: { stroke: string; text: string }[] = [
    { stroke: "Breaststroke", text: "Br" },
    { stroke: "Butterfly", text: "Fly" },
    { stroke: "Backstroke", text: "Ba" },
    { stroke: "Breaststroke", text: "Br" },
    { stroke: "Butterfly", text: "Fly" },
    { stroke: "Backstroke", text: "Ba" },
    { stroke: "Breaststroke", text: "Br" },
    { stroke: "Butterfly", text: "Fly" },
  ];

  const rows: { k: string; you: string; them: string; res: string; win: boolean }[] = [
    { k: "Set time", you: "3:54", them: "4:00", res: "Scott, by 6s", win: true },
    { k: "Breaststroke", you: "31.5s", them: "33.0s", res: "Scott, by 1.5s", win: false },
    { k: "Butterfly", you: "25.8s", them: "25.8s", res: "Even", win: false },
    { k: "Backstroke", you: "30.8s", them: "31.7s", res: "Even", win: false },
  ];
</script>

<div class="teaser" aria-label="Example of a shared set">
  <div class="set-name">
    <span class="t">Killer BS<span class="tag">Matched 8/8</span></span>
    <span class="d">200 m</span>
  </div>
  <div class="strip-row">
    <span class="who">Both</span>
    <span class="chips">
      {#each chips as c, i (i)}
        <span class="chip" style="background: {strokeColor(c.stroke)}; color: {contrastTextOn(strokeColor(c.stroke))}">{c.text}</span>
      {/each}
    </span>
  </div>
  <div class="speed">
    <div class="hdr"><span></span><span>Scott</span><span>Ryan</span><span></span></div>
    {#each rows as r (r.k)}
      <div class="row">
        <span class="k">{r.k}</span>
        <span class="you">{r.you}</span>
        <span class="them">{r.them}</span>
        <span class="res" class:w={r.win}>{r.res}</span>
      </div>
    {/each}
  </div>
  <p class="quiet">
    Example: Scott and Ryan swam this set together. Matched 8/8 means both watches logged the same 8 lengths.
  </p>
</div>

<style>
  .teaser {
    background: var(--bg-card);
    border: 1px solid var(--divider);
    border-radius: var(--radius-card);
    padding: 14px 16px;
    opacity: 0.92;
  }
  .set-name {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: var(--space-2);
    margin-bottom: var(--space-2);
  }
  .set-name .t {
    font-weight: 600;
    font-size: 18px;
    color: var(--text-primary);
  }
  .set-name .d {
    font-size: 13px;
    color: var(--text-muted);
    white-space: nowrap;
  }
  .tag {
    display: inline-block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    padding: 2px 8px;
    border-radius: 6px;
    vertical-align: 2px;
    margin-left: 6px;
    background: var(--win-bg, #1e2e22);
    color: var(--win, #9cd8a8);
  }
  .strip-row {
    display: flex;
    align-items: flex-start;
    gap: var(--space-2);
    margin-bottom: 6px;
  }
  .strip-row .who {
    width: 46px;
    font-size: 12px;
    font-weight: 500;
    color: var(--text-muted);
    padding-top: 5px;
  }
  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 3px;
    flex: 1;
  }
  .chip {
    flex: 1 1 0;
    min-width: 24px;
    max-width: 29px;
    height: 24px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 600;
  }
  .speed {
    margin-top: 10px;
    border-top: 1px solid var(--divider);
    padding-top: 10px;
  }
  .hdr {
    display: flex;
    font-size: 11px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--text-dim);
    padding-bottom: 4px;
  }
  .hdr span:nth-child(1) { width: 88px; }
  .hdr span:nth-child(2), .hdr span:nth-child(3) { width: 62px; }
  .hdr span:nth-child(4) { flex: 1; text-align: right; }
  .row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 3px 0;
    font-size: 15px;
  }
  .row .k {
    color: var(--text-muted);
    font-size: 13px;
    width: 88px;
    flex-shrink: 0;
  }
  .row .you, .row .them {
    font-variant-numeric: tabular-nums;
    color: var(--text-primary);
    width: 62px;
    flex-shrink: 0;
  }
  .row .them { color: var(--text-body); }
  .row .res {
    font-size: 13px;
    color: var(--text-muted);
    flex: 1;
    text-align: right;
    white-space: nowrap;
  }
  .row .res.w {
    color: var(--win, #9cd8a8);
    font-weight: 600;
  }
  .quiet {
    margin: var(--space-2) 0 0;
    font-size: 13px;
    color: var(--text-muted);
  }
</style>
